import { render, staticRenderFns } from "./OfferPositionBoilerplateEdit.vue?vue&type=template&id=7bbf6a5a&scoped=true"
import script from "./OfferPositionBoilerplateEdit.vue?vue&type=script&lang=js"
export * from "./OfferPositionBoilerplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf6a5a",
  null
  
)

export default component.exports